//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 事务处理类型查询
const transactionTypeList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/transactionType/list.vue')),
    'transactionTypeList'
  );
// 事务处理类型设置
const transactionTypeSet = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/transactionType/set.vue')),
    'transactionTypeSet'
  );

const transactionTypeRouter = {
  path: '/transactionType',
  component: index,
  children: [
    {
      path: 'list',
      name: 'transactionTypeList',
      component: transactionTypeList,
      meta: {
        keepAlive: true,
        title: '事务处理类型查询',
      },
    },
    {
      path: 'set',
      name: 'transactionTypeSet',
      component: transactionTypeSet,
      meta: {
        keepAlive: true,
        title: '事务处理类型设置',
      },
    },
  ],
};
export default transactionTypeRouter;
